import vue from 'vue'
import storage from 'good-storage'
import { resCode } from 'api/config'
import { clientId, clientSecret } from 'common/js/reqdata'
import wx from 'weixin-js-sdk'
import { Hub } from 'common/js/hub'
import { urls } from 'api/apiUrlConfig'
import { postJsonService } from '@/api/config'

function getVersion () {
  return postJsonService(urls.apiversion, { version: 'V20180329' })
}
/// 0=加西亚，1=新干线观察 获取Android下载地址
function getAndroidUrl (type) {
  const url = urls.getAndroidUrl
  return vue.axios.post(url, {
    reqdata: { type: type }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}
function refershToken () {
  const url = urls.refreshtoken
  const token = storage.get('token') || ''
  if (!token) {
    return
  }
  return vue.axios.post(url, {
    reqdata: {
      clientId: clientId,
      clientSecret: clientSecret,
      grantType: 'refresh_token',
      refreshToken: token.refreshToken
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 需要检测的JS接口列表，所有JS接口列表见附录2,
const jsApiListParams = ['updateTimelineShareData', 'updateAppMessageShareData', 'scanQRCode', 'onMenuShareWeibo', 'chooseImage', 'previewImage']

function setWeiChartConfig (debug = false) {
  let isAndroid = /Android/.test(navigator.appVersion)
  let userUrl = isAndroid ? location.href : Hub.commonUrl
  let urlReturn = encodeURIComponent(userUrl)
  const url = urls.jssdkconfig
  return vue.axios.post(url, {
    reqdata: urlReturn
  }).then((res) => {
    if (res.data.code === resCode.ERR_OK) {
      wx.config({
        debug: debug,
        appId: res.data.resdata.appId, // 必填，公众号的唯一标识
        timestamp: res.data.resdata.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.resdata.nonceStr, // 必填，生成签名的随机串
        signature: res.data.resdata.signature, // 必填，签名，见附录1
        jsApiList: jsApiListParams,
        openTagList: ['wx-open-launch-weapp']/// ```// 可选，需要使用的开放标签列
      })
      return Promise.resolve(1)
    } else {
      return Promise.resolve(0)
    }
  })
}
/// ！！！ 测试环境 因为 域名 未配置原因， 所以，测试该转发效果，需要到正式环境去验证
function wxReady () {
  console.log('checkJsApi')
  wx.ready(() => {
    wx.checkJsApi({
      jsApiList: jsApiListParams,
      success: function (res) {
        console.log('checkJsApi', res)
      }
    })
  })
}

function wxError () {
  return new Promise((resolve, reject) => {
    wx.error((res) => {
      console.log('wxError', res)
    })
  })
}

function scanQRcode () {
  return new Promise((resolve, reject) => {
    wx.scanQRCode({ // 扫一扫
      needResult: 1, // 是否微信处理 0 微信处理
      scanType: ['qrCode', 'barCode'], // "qrCode"," " 二维还是一维
      success: function (res) {
        resolve(res.resultStr)
      },
      error: function (res) {
        alert('error')
        reject(res)
      }
    })
  })
}

function shardCOM (title, url, icon, desc) {
  wx.updateTimelineShareData({
    title: title, // 分享标题
    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: icon, // 分享图标
    desc: desc,
    success () {
    },
    cancel () {
    }
  })
}

function shareQZone (title, url, icon, desc) {
  wx.updateTimelineShareData({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: url, // 分享链接
    imgUrl: icon, // 分享图标
    success: function () {
    },
    cancel: function () {
    }
  })
}

function shareWeiBo (title, url, icon, desc) {
  wx.onMenuShareWeibo({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: url, // 分享链接
    imgUrl: icon, // 分享图标
    success: function () {
    },
    cancel: function () {
    }
  })
}

function shareQQ (title, url, icon, desc) {
  wx.updateTimelineShareData({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: url, // 分享链接
    imgUrl: icon, // 分享图标
    success: function () {
    },
    cancel: function () {
    }
  })
}

function shareFir (title, url, icon, desc) {
  wx.updateAppMessageShareData({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: icon, // 分享图标
    type: 'link', // 分享类型,music、video或link，不填默认为link
    success: function () {
    },
    cancel: function () {
    }
  })
}

function setWXReady (title, url, imgUrl, desc) {
  wxReady()
  wx.ready(() => {
    shareFir(title, url, imgUrl, desc)
    shardCOM(title, url, imgUrl, '')
    shareWeiBo(title, url, imgUrl, desc)
    shareQQ(title, url, imgUrl, desc)
    shareQZone(title, url, imgUrl, desc)
    console.log('ready', title, desc)
  })
  wx.error(function (res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    console.log('wx.error', res)
  })
}
export {
  getVersion,
  refershToken,
  setWeiChartConfig,
  wxReady,
  scanQRcode,
  wxError,
  shardCOM,
  shareFir,
  shareQZone,
  shareWeiBo,
  shareQQ,
  setWXReady,
  getAndroidUrl
}



// WEBPACK FOOTER //
// ./src/api/baseapi.js